import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CloStepNavigation} from '../stepnavigation';
import {CloStepNavigationItem} from './stepnavigationitem';
export {CloStepNavigationItem} from './stepnavigationitem';

@NgModule({
  declarations: [CloStepNavigationItem],
  exports: [CloStepNavigationItem],
  imports: [ CommonModule ],
  entryComponents: [CloStepNavigation]
})
export class StepnavigationitemModule { }
